import { z } from 'zod';
import type {
  ConfirmInboundReceiptDraftRequest,
  ConfirmInboundReceiptDraftResponse,
} from './confirm-inbound-receipt-draft.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const ConfirmInboundReceiptDraftRequestSchema: z.ZodType<ConfirmInboundReceiptDraftRequest> =
  z
    .object({
      companyId: z.uuid(),
      draftId: z.uuid(),
      stationId: z.uuid(),
    })
    .strict();

export const ConfirmInboundReceiptDraftResponseSchema: z.ZodType<ConfirmInboundReceiptDraftResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
    })
    .strict();
